<template>
  <div class="notification-bubble red font-weight-bold white--text" :style="dimensions">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    size: { type: Number, required: false, default: 20 }
  },
  data() {
    return {
      dimensions: {
        height: `${this.size}px`,
        width: `${this.size}px`
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.notification-bubble {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  text-align: center;
  border-radius: 50%;
}
</style>
